import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';
import NoSSR from 'Components/NoSSR';
import History from 'Store/history';

const TribunV2 = loadable(() => pMinDelay(import('./TribunV2'), 300), {
  fallback: <Loading />
});

const AsyncTribunV2 = props => {
  let title = 'Tribun | Bilyoner';
  let description = 'İddaa Bilyoner’de oynanır! Peki ya kuponların? İddaa kuponlarını takip etmek ve kazanmanın keyfine varmak için Bilyoner ile kuponlarını takipte kal!';

  let meta;

  if (props.location.pathname.includes('/tribun/kupon')) {
    const metaConfiguration = props.metaConfiguration['/tribun/kupon'];
    title = metaConfiguration?.title;
    description = metaConfiguration.description;
    meta = metaConfiguration.meta;
  }

  let pageBackground = 'bg-green';
  switch (History?.location?.pathname) {
    case '/tribun/uzay/yardim':
      pageBackground = 'bg-smoke-grey tribun__new-header';
      break;

    default:
      pageBackground = 'tribun__new-header';
      break;
  }

  const pageConfig = {
    headerType: 'full',
    footerType: 'mobile-none',
    loadGameListFull: true,
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent?.device?.type } ${pageBackground}`
      },
      title,
      description,
      meta
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <NoSSR>
        <TribunV2 { ...props }/>
      </NoSSR>
    </ApplicationLayout>
  );
};

AsyncTribunV2.propTypes = {
  userAgent: PropTypes.object,
  metaConfiguration: PropTypes.object,
  location: PropTypes.object
};

export default AsyncTribunV2;
